module.exports = __webpack_public_path__ + "img/classroom_1.37adb860.jpg";